module.exports = __webpack_public_path__ + "static/media/SPECTRIO_WHITE_BG.e0f9dc01.png";